import React, {useState} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import SMCButton from '../../../../components/Simple/SMCButton';
import TemplateEditorModal from '../../../PopupPages/TemplateEditors/TemplateEditorModal';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {isUserAdminSelector} from '../../../../store/selectors/user.selectors';

const pageSchema = PortalSettingsGetSchema.pages.notificationSummaryMessages;
const pageId = pageSchema.pageId;

function PortalSettingsSummaryMessagesNotifications({
    portalSettingsObject,
    setPortalSettingsData,
    isUserAdmin
}) {
    const { t } = useTranslation();

    const pageData = portalSettingsObject[pageId];

    const userSummary      = pageData[pageSchema.userSummary];
    const communitySummary = pageData[pageSchema.communitySummary];
    const generalMessage   = pageData[pageSchema.generalMessage];

    const [isUserSummaryEditorOpen, setIsUserSummaryEditorOpen] = useState(false);
    const [isCommunitySummaryEditorOpen, setIsCommunitySummaryEditorOpen] = useState(false);
    const [isGeneralMessageEditorOpen, setIsGeneralMessageEditorOpen] = useState(false);

    return (
        <EditorLayout labelWidth={400} lineHeight="32px">
            {/* User details */}
            <RowLayout spacing="4px">
                <SMCLabel inline useContextWidth>{t('SMC_SETTINGS_NOTIFY_SUMMARY_USER')}</SMCLabel>
                <SMCButton onClick={() => setIsUserSummaryEditorOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
            </RowLayout>
            {/* Community details */}
            <RowLayout spacing="4px">
                <SMCLabel inline useContextWidth>{t('SMC_SETTINGS_NOTIFY_SUMMARY_COMMUNITY')}</SMCLabel>
                <SMCButton onClick={() => setIsCommunitySummaryEditorOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
            </RowLayout>
            {/* General mail template */}
            <RowLayout spacing="4px">
                <SMCLabel inline useContextWidth>{t('SMC_SETTINGS_NOTIFY_GENERAL')}</SMCLabel>
                <SMCButton onClick={() => setIsGeneralMessageEditorOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
            </RowLayout>
            
            {/* Popup windows */}
            <TemplateEditorModal
                isOpen={isUserSummaryEditorOpen}
                onRequestClose={() => setIsUserSummaryEditorOpen(false)}
                defaultObject={userSummary}
                onSuccess={val => {
                    setPortalSettingsData([pageId, pageSchema.userSummary], val);
                    setIsUserSummaryEditorOpen(false);
                }}
                templateName="userSummary"
                hasAdministratorsTab={isUserAdmin}
            />
            <TemplateEditorModal
                isOpen={isCommunitySummaryEditorOpen}
                onRequestClose={() => setIsCommunitySummaryEditorOpen(false)}
                defaultObject={communitySummary}
                onSuccess={val => {
                    setPortalSettingsData([pageId, pageSchema.communitySummary], val)
                    setIsCommunitySummaryEditorOpen(false);
                }}
                templateName="communitySummary"
                hasAdministratorsTab={isUserAdmin}
            />
            <TemplateEditorModal
                isOpen={isGeneralMessageEditorOpen}
                onRequestClose={() => setIsGeneralMessageEditorOpen(false)}
                defaultObject={generalMessage}
                onSuccess={val => {
                    setPortalSettingsData([pageId, pageSchema.generalMessage], val)
                    setIsGeneralMessageEditorOpen(false);
                }}
                templateName="generalMsg"
                hasAdministratorsTab={isUserAdmin}
            />
        </EditorLayout>
    )
}

const mapStateToProps = state => ({
    isUserAdmin: isUserAdminSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(PortalSettingsSummaryMessagesNotifications);